// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"6d5a3a06","321":"24566b92","345":"a0144e90","734":"b744d030","837":"35aa6c97","972":"7d4ef6bb"}[chunkId] + ".js";
};